import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';

const INITIAL_PREVIOUS_ROUTE = '++INITIAL_PREVIOUS_ROUTE++';

export const usePageLoader = (): { isAnimating: boolean } => {
  const router = useRouter();

  const [isAnimating, setIsAnimating] = useState(false);
  const [previousRoute, setPreviousRoute] = useState(INITIAL_PREVIOUS_ROUTE);

  const handlePageChangeStop = (url: string) => {
    setIsAnimating(false);
    window.analytics.page(url);
  };

  useEffect(() => {
    const handlePageChangeStart = (url: string) => {
      const currentBaseRoute = getRouteWithoutQuery(url);
      if (
        previousRoute !== INITIAL_PREVIOUS_ROUTE &&
        currentBaseRoute !== previousRoute
      ) {
        setIsAnimating(true);
      }
      setPreviousRoute(currentBaseRoute);
    };

    router.events.on('routeChangeStart', handlePageChangeStart);
    router.events.on('routeChangeComplete', handlePageChangeStop);
    router.events.on('routeChangeError', handlePageChangeStop);

    return () => {
      router.events.off('routeChangeStart', handlePageChangeStart);
      router.events.off('routeChangeComplete', handlePageChangeStop);
      router.events.off('routeChangeError', handlePageChangeStop);
    };
  }, [previousRoute, router.events]);

  return { isAnimating };
};

function getRouteWithoutQuery(route: string) {
  return route.split('?')[0];
}
